import { useContext, useEffect } from 'react'
import { Formik, useFormikContext } from 'formik'
import { AnySchema } from 'yup'

import { formatValuesForFormik } from 'utils/helpers'
import { Context } from 'lib/context/probate-estate-request-status'

const InnerForm = <P extends object>({
  component: Component,
  ...rest
}: { component: React.ComponentType<P> } & P) => {
  const context = useContext(Context)

  const { errors, setStatus, setTouched } = useFormikContext()

  useEffect(() => {
    if (context?.highlightEmpty) {
      setStatus({ highlightEmpty: context.highlightEmpty })
    }
  }, [context?.highlightEmpty, setStatus])

  useEffect(() => {
    setTouched(errors)
  }, [errors, setTouched])

  return <Component {...(rest as P)} />
}

const withForm = <P extends object>(Component: React.ComponentType<P>) => {
  const OuterForm = ({
    enableReinitialize = false,
    initialValues,
    validationSchema,
    ...rest
  }: P & {
    enableReinitialize?: boolean
    initialValues: Record<string, unknown>
    validationSchema?: AnySchema
  }) => {
    const context = useContext(Context)
    return (
      <Formik
        enableReinitialize={enableReinitialize}
        initialStatus={{ highlightEmpty: context?.highlightEmpty }}
        initialValues={formatValuesForFormik(initialValues)}
        validationSchema={validationSchema}
        validateOnChange={false}
        validateOnMount
        onSubmit={() => undefined}
      >
        <InnerForm component={Component} {...(rest as P)} />
      </Formik>
    )
  }

  return OuterForm
}

export default withForm
